'use strict';

namespace Core {

    class MailingListUnsubscribe {

        closeFn: Function;

        private email: string;
        private emailPattern: RegExp = /^\S+@\S+\.\S+[^\.]$/;

        private success: boolean = false;
        private error: boolean = false;

        constructor (
            private authService: any,
            private $scope: ng.IScope,
            private analytics,
            private modalService
        ) {
        }

        submit (): void {
            const data = {
                Email: this.email,
                Source: 'TravelRepublic',
                SourceDetail: 'Newsletter Unsubscribe Footer'
            };

            this.analytics.track('mixpanel', 'GDPRSubmit');
            this.authService
                .unsubscribeFromNewsletter(data)
                .success(() => {
                    this.success = true;
                    this.error = false;
                    this.resetForm();
                })
                .error(() => {
                    this.error = true;
                });
        }

        continueBrowsing (event: object): void {
            this.success = false;
            this.modalService.close();
            this.closeFn({ event });
        }

        resetForm (): void {
            this.$scope.unsubscribeListForm.$setPristine();
            this.$scope.unsubscribeListForm.$setUntouched();
            this.email = '';
        }
    }

    angular
        .module('core')
        .directive('mailingListUnsubscribe', (): ng.IDirective => {
            return {
                scope: {},
                bindToController: {
                    closeFn: '&'
                },
                restrict: 'E',
                replace: true,
                controller: MailingListUnsubscribe,
                controllerAs: 'mus',
                templateUrl: 'partials/home/directivetemplate?type=mailinglistunsubscribe'
            };
        });
}
